import { TextInput, Icon } from '@paypalcorp/pp-react'
import styles from '../integration-builder.module.css'
import React, { FC } from 'react'
import withAnalytics from '../../../utils/withAnalytics'
import { removeGAParam } from '../../../components/pp-react-wrappers'

type CardGeneratorLayoutProps = {
  data: Record<string, any>[]
  testid: string
}

const CardGeneratorLayout: FC<CardGeneratorLayoutProps> = ({
  data,
  testid,
}) => {
  const [copied, setCopied] = React.useState('')
  const fptiData = typeof window !== `undefined` && window.fpti
  const recordAnalytics = (fieldName: string) => {
    if (fptiData && window.PAYPAL?.analytics?.instance) {
      window.PAYPAL.analytics.instance.record({
        data: {
          ...fptiData,
          component: 'devdiscoverynodeweb',
          space_key: 'SKEXJE',
          e: 'cl',
          event_action: `copy_field_${fieldName}`,
          event_category: testid,
          link: testid,
          page_name: fptiData && fptiData.page.replace(/:/g, '_'),
          event_name:
            fptiData &&
            `${fptiData.page.replace(/:/g, '_')}_copy_field_${fieldName}`,
          pu: removeGAParam(window.location.href),
        },
      })
    }
  }
  const copyToClipboard = (name: string, value: string) => {
    navigator.clipboard.writeText(value).then(() => {
      setCopied(`${name}-${value}`)
    })
    recordAnalytics(name)
  }

  return (
    <div
      data-testid={testid}
      className={styles.checkout_simulator__card_generator}
    >
      {data?.map(({ name, label, value }) => (
        <div
          className={styles.checkout_simulator__card_generator_text_wrapper}
          key={name}
        >
          {/* Not instrumenting this input as it is disabled */}
          <TextInput name={name} value={value} label={label} disabled />
          <div
            className={
              styles.checkout_simulator__card_generator_background_circle
            }
          >
            {copied === `${name}-${value}` ? (
              <Icon
                className={styles.integration_builder__copyIconSuccess}
                name="checkmark-background"
                color="sysColorSuccessMain"
              />
            ) : (
              <Icon
                className={styles.integration_builder__copyIcon}
                data-testid={`${testid}-${name}-icon`}
                name="copy-to-clipboard"
                color="sysColorPrimaryMain"
                onClick={() => copyToClipboard(name, value)}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

export default withAnalytics(CardGeneratorLayout)
